import {useCallback, useState} from 'react';
import {NativeModules} from 'react-native';
import {useDispatch} from 'react-redux';

import {addUserData, checkPayment, createPaymentIos,} from '../../../store/actions';
import {isIOS} from '../../../lib/deviceInfo';

export const shopId = '314220';
export const clientApplicationKey =
    'live_MzE0MjIwzpGrKbT63nCXFzBm-BXUOzzwIRdA0VL28sc';
const {YooKassa} = NativeModules;

export const usePayment = () => {
    const [amount, setAmount] = useState('');
    const [amountError, setAmountError] = useState('');

    const [satisfaction, setSatisfaction] = useState('');
    const [comment, setComment] = useState('');

    //const user = useSelector(selectUser);
    const [email, setEmail] = useState('');
    const [hasUser, setHasUser] = useState(false);

    //const userPhoneNumber = user?.phoneNumber;

    const [isFetching, setIsFetching] = useState(false);

    const [visiblePaymentSuccessModal, setVisiblePaymentSuccessModal] = useState(
        false,
    );
    const [visiblePaymentFailModal, setVisiblePaymentFailModal] = useState(false);
    const [
        isPaymentMethodSberbankExternal,
        setIsPaymentMethodSberbankExternal,
    ] = useState(false);
    const [visiblePaymentWidgetModal, setVisiblePaymentWidgetModal] = useState(
        false,
    );
    const [confirmationToken, setConfirmationToken] = useState('');
    const [paymentId, setPaymentId] = useState('');

    const resetModal = useCallback(() => {
        setVisiblePaymentSuccessModal(false);
        setIsPaymentMethodSberbankExternal(false);
        setConfirmationToken('');
        setPaymentId('');
    }, []);

    const [errorText, setErrorText] = useState('');

    const reset = () => {
        setAmount('');
        setAmountError('');
        setSatisfaction('');
        setComment('');
        setIsFetching(false);
        resetModal();
        setErrorText('');
        setEmail('');
        setHasUser(false);
    };
    const resetAndOpenSuccessModal = (isIosBankCardPayment) => {
        reset();
        if (isIosBankCardPayment) {
            setTimeout(() => {
                setVisiblePaymentSuccessModal(true);
            }, 500);
        } else {
            setVisiblePaymentSuccessModal(true);
        }
    };

    const dispatch = useDispatch();

    const onPressPaymentIos = useCallback(() => {
        setIsFetching(true);
        // setVisiblePaymentWidgetModal(true);
        dispatch(
            createPaymentIos(
                {
                    //amountValue: amount,

                    // uid: user?.uid || '', // user_id: user?.uid || '',
                    email: email || '',
                    // user_name: user?.displayName || '',
                    // user_phone: user?.phoneNumber || '',
                    platform: isIOS ? 'iOS' : 'Android',

                },
                (isSuccess, result) => {
                    setIsFetching(false);
                    console.log(JSON.stringify(result, null, 2));
                    if (isSuccess) {
                        const {
                            hasUser
                        } = result;
                        setHasUser(hasUser);
                        //console.log(JSON.stringify(result, null, 2));
                    } else {
                        //setConfirmationToken('');
                        let errorTextMessage;
                        if (result.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            errorTextMessage = result.response.data;
                        } else if (result.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            errorTextMessage = result.request;
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            if (result.code == '100') {
                                errorTextMessage = 'не подключиться к серверу';
                            } else {
                                errorTextMessage = result.message;
                            }
                        }
                        console.error('Payment api server error = ', errorTextMessage);
                        setErrorText(
                            `Произошла ошибка: ${errorTextMessage}`,
                        );
                    }
                },
            ),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email, dispatch]);

    const onCheckPayment = useCallback(() => {
        setIsFetching(true);
        dispatch(
            checkPayment(
                {
                    payment_id: paymentId,
                    uid: user?.uid,
                },
                (isSuccess, result) => {
                    setIsFetching(false);
                    //console.log(JSON.stringify(result, null, 2));
                    if (isSuccess) {
                        const {status, isTrial, paidDate} = result;
                        console.log(JSON.stringify(result, null, 2));
                        if (status == 'succeeded') {
                            setVisiblePaymentSuccessModal(true);
                        } else {
                            setVisiblePaymentFailModal(true);
                        }
                        dispatch(addUserData({isTrial, paidDate}));
                    } else {
                        setConfirmationToken('');
                        setPaymentId('');
                        console.error('Payment api server error = ', errorTextMessage);
                        setErrorText('Произошла ошибка на сервере API.');
                    }
                },
            ),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentId]);

    return {
        amount,
        setAmount,
        amountError,
        setAmountError,
        satisfaction,
        setSatisfaction,
        comment,
        setComment,
        isFetching,

        visiblePaymentSuccessModal,
        setVisiblePaymentSuccessModal,
        visiblePaymentFailModal,
        setVisiblePaymentFailModal,
        visiblePaymentWidgetModal,
        setVisiblePaymentWidgetModal,
        isPaymentMethodSberbankExternal,
        resetModal,
        errorText,
        setErrorText,
        confirmationToken,
        onCheckPayment,
        setConfirmationToken,

        setEmail,
        email,
        onPressPaymentIos,
        hasUser,
        reset,
    };
};
